import { styled } from "@mui/system";
import { Button, Skeleton } from "@mui/material";
import Stack from "@mui/material/Stack";

export const ChipButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ active }) => ({
    borderRadius: "0",
    padding: "0",
    fontSize: "14px",
    fontWeight: 500,
    height: "32px",
    minWidth: "0",
    textTransform: "capitalize",
    color: "var(--community-color-primary-text)",
    borderBottom: active
        ? "2px solid var(--community-color-primary-text)"
        : "2px solid transparent",
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: "transparent",
    },
}));

export const SortingChipsContainer = styled(Stack)({
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
});

export const ChipSkeleton = styled(Skeleton)({
    width: "77px",
    borderRadius: 0,
    transform: "scale(1)",
});
